<template>
  <div class="v-orders container">
    <!-- action-bar -->
    <action-bar class="head-bar action-bar" :b="true" @back="back">
      <div class="left" slot="left">
        <button @click.stop="$router.push('/home/hall')">{{ '购彩大厅' }}</button>
      </div>

      <div class="title" slot="title">
        <span>{{ title }}</span>
      </div>
    </action-bar>

    <!-- main-table -->
    <div class="v-main">
      <v-table :data="data" :columns="columns" :isYs="false">
        <span slot="count" slot-scope="{row}">{{ row.count }}</span>
      </v-table>
    </div>

    <!--  -->
    <div class="count-box">
      <p>
        共投注额 <span class="red">{{ bet_money }}</span>元
      </p>
    </div>
  </div>
</template>

<script>
import ActionBar from '@/components/action-bar';
import VTable from '@/components/table';
import { unsettle2 } from '@/service/report';
import objectPath from "object-path";

export default {
  name: "v-orders",
  components: {ActionBar, VTable},
  data() {
    return {
      title: '未结算',
      data: [],
      allcount: 0,
      bet_money: 0,
      commission: 0,
      result: 0
    }
  },

  methods: {
    back() {
      this.$router.go(-1);
    }
  },

  created() {
    let query = this.$route.query;
    this.title += '--';
    if (query.date) {
      this.date = query.date;
      this.title = query.date + '--'
    }
    if (query.lottery_name) {
      this.title += query.lottery_name
    }
    unsettle2(query.lottery_type).then(res => {
      const resData = objectPath.get(res, 'data') || [];
      this.data = resData.map(item => {
        item.content = item.class2 + ',' + item.class3;
        item.date_time = item.date_time.slice(10);
        if(item.status==3){
          item.status = '<span class="red">取消</span>';
        }else{
          item.status = '<span class="green">有效</span>';
        }
        return item;
      });

      let allcount = 0;
      let bet_money = 0;
      let commission = 0;
      let result = 0;

      this.data.forEach(item => {
        allcount += item.count;
        bet_money += item.money;
        commission += item.commission;
        result += item.result;
      })
      this.allcount = allcount;
      this.bet_money = bet_money;
      this.commission = commission;
      this.result = result;
    });
  },

  computed: {
    columns() {
      return [
        {
          title: '时间',
          key: 'date_time',
          width: '10%',
          align: 'center'
        },

        {
          title: '期号',
          key: 'period',
          width: '15%',
          align: 'center'
        },

        {
          title: '投注内容',
          key: 'content',
          width: '20%',
          align: 'center'
        },
        {
          title: '赔率',
          key: 'odds',
          width: '10%',
          align: 'center'
        },
        {
          title: '投注',
          key: 'money',
          width: '10%',
          align: 'center'
        },
        {
          title: '退水',
          key: 'rebate',
          width: '10%',
          align: 'center'
        },
        {
          title: '可赢',
          key: 'win',
          width: '10%',
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: '10%',
          align: 'center'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.v-orders {
  .head-bar {
    z-index: 100;
    position: relative;

    .left {
      width: 140px;

      > button {
        height: 60px;
      }
    }

    .title {
      display: flex;
      text-align: center;
      align-items: center;
      font-weight: bold;
      justify-content: center;

      > button {
        width: 50px;
        height: 50px;
        border: 1px solid #b40f06;
        position: relative;
        margin-left: 10px;
        border-radius: 25px;

        &:after {
          top: 22px;
          left: 13px;
          display: block;
          content: "";
          position: absolute;
          border-top: 10px solid #fff;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-bottom: none;
          transition: transform 0.2s linear;
        }
      }
    }


    button {
      color: #fff;
      border: 1px solid #b70a00;
      padding: 0 16px;
      position: relative;
      font-size: 24px;
      background: #e8291d;
      background: -webkit-gradient(linear, 0 0, 0 70%, from(#f94539), to(#e8291d));
      box-shadow: 0 2px 2px #fc7f77 inset;
      border-radius: 10px;
    }
  }

  .v-main {
    position: relative;
    box-sizing: border-box;
    padding-bottom: 60px;
  }

  .count-box {
    height: 100px;
    font-size: 24px;
    background: #fffbec;
    flex-shrink: 0;
    border-top: 1px solid #dfdddd;
    box-sizing: border-box;

    p {
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e2d9b5;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/orderDetail/index.vue